import React from "react";

interface TextAreaProps {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  placeholder?: string; // Optional placeholder
  rows?: number; // Optional rows for textarea
  onClear?: () => void; // Optional clear function
}

const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  className = "",
  placeholder = "",
  rows = 3, // Default to 3 rows
  onClear,
}) => (
  <div className="relative flex items-center w-full">
    <textarea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className={`textarea-base ${className}`}
    />
    {value && onClear && (
      <button
        type="button"
        onClick={onClear}
        className="absolute right-0 mr-2 text-gray-500 hover:text-gray-700"
      >
        &times;
      </button>
    )}
  </div>
);

export default TextArea;
